export const Panels = (function () {
	'use strict';

	let $target;

	function init() {
		$target = $('[data-panel-target]');
		if($target){
			events();
		}
	}

	function events() {
		let $panelsContent = $('.panels__content');
		$panelsContent.hide();

		$target.eq(0).addClass('active');
		$panelsContent.eq(0).show();
		
		$target.each(function(){
			let $btn = $(this);
			$btn.on('click', function(){
				if($(this).hasClass('active')) {
					return;
				}
				let $btnTarget = $(this).data('panel-target');
				let $panel = $('.panels').find('#' + $btnTarget);

				$target.removeClass('active');
				$(this).addClass('active');
				
				$panelsContent.hide();
				$panel.show();
				// console.log($panel)
			});
		});
	}

	return {
		init: init,
	};
})();
